export default __webpack_public_path__ + "static/media/pictogramMail128.de6fac18.svg";